import { createContext } from 'react';
import { Accountant, User, ViewSelectProp } from '../../models/User';
import utils from 'utils';
import { Listing } from 'models/Listing';
import { DropzoneDelete, DropzoneUpload } from 'models/Dropzone';
import { Enterprise, EnterpriseMember } from 'models/Enterprises';

export type CallbackConfig = {
  skipToast?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
};

type CurrentUserContextProps = {
  currentUser: User;
  isUserVerified: boolean;
  isSuperAdmin: boolean;
  isUltraAdmin: boolean;
  hasEnterprise: boolean;
  isEnterpriseHead: boolean;
  isRWCMember: boolean;
  enterpriseMember: EnterpriseMember;
  enterprise: Enterprise;
  openVerificationModal: (
    shouldCheckPhone?: boolean,
    listingId?: string,
  ) => void;
  openPhoneVerificationModal: () => void;
  patchCurrentUser: (
    user: Partial<User>,
    config?: CallbackConfig,
  ) => Promise<void>;
  updateUnreadMessages: () => void;
  updateUnreadMessagesUnread: () => void;
  uploadProfileImage: DropzoneUpload;
  deleteProfileImage: DropzoneDelete;
  setCurrentUser: React.Dispatch<React.SetStateAction<User>>;
  isListingEnquirableAndWatchableByMe: (listing: Listing) => [boolean, boolean];
  updateAccountants: (accountant: Partial<Accountant>) => void;
  changePassword: (
    value: { oldPassword: string; newPassword: string },
    config?: CallbackConfig,
  ) => void;
  updateView: (key: ViewSelectProp, value: boolean) => void;
};

export default createContext<Partial<CurrentUserContextProps>>({
  currentUser: null,
  isUserVerified: false,
  isSuperAdmin: false,
  isUltraAdmin: false,
  hasEnterprise: false,
  isEnterpriseHead: false,
  isRWCMember: false,
  enterpriseMember: null,
  enterprise: null,
  openVerificationModal: utils.noop,
  openPhoneVerificationModal: utils.noop,
  changePassword: utils.noop,
  patchCurrentUser: utils.noop,
  uploadProfileImage: utils.noop,
  deleteProfileImage: utils.noop,
  updateUnreadMessages: utils.noop,
  updateUnreadMessagesUnread: utils.noop,
  setCurrentUser: utils.noop,
  isListingEnquirableAndWatchableByMe: utils.noop,
  updateAccountants: utils.noop,
  updateView: utils.noop,
});
